import { createFileRoute, Link } from '@tanstack/react-router';
import { useSocios, useDeleteSocio } from '@/lib/hooks';
import { useUIStore } from '@/lib/store';

export const Route = createFileRoute('/_authed/socios/')({
  component: SociosListPage,
});

function SociosListPage() {
  const { data, isLoading, error } = useSocios();
  const del = useDeleteSocio();
  const search = useUIStore((s) => s.searchQueries['socios'] ?? '');
  const setSearch = useUIStore((s) => s.setSearchQuery);

  const filtered = (data ?? []).filter(
    (s) => !search || `${s.nome} ${s.papel} ${s.classe}`.toLowerCase().includes(search.toLowerCase()),
  );

  return (
    <>
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '1rem', gap: '1rem' }}>
        <h1 style={{ margin: 0 }}>Sócios</h1>
        <div style={{ display: 'flex', gap: '0.5rem' }}>
          <input
            placeholder="Buscar…"
            value={search}
            onChange={(e) => setSearch('socios', e.target.value)}
            style={{ minWidth: 200 }}
          />
          <Link to="/socios/$slug" params={{ slug: 'new' }} className="btn">+ Novo</Link>
        </div>
      </div>

      {isLoading && <p><span className="spinner" /> Carregando…</p>}
      {error && <p style={{ color: '#dc2626' }}>Erro: {(error as Error).message}</p>}

      {data && (
        <table>
          <thead>
            <tr><th></th><th>Nome</th><th>Papel</th><th>Classe</th><th>Level</th><th></th></tr>
          </thead>
          <tbody>
            {filtered.map((s: any) => (
              <tr key={s.slug}>
                <td>{s.foto && <img className="photo" src={s.foto} alt={s.nome} loading="lazy" />}</td>
                <td><b>{s.nome}</b><div style={{ fontSize: '0.7rem', color: 'var(--muted)' }}><code>{s.slug}</code></div></td>
                <td>{s.papel}</td>
                <td>{s.classe}</td>
                <td>{s.level}</td>
                <td>
                  <Link to="/socios/$slug" params={{ slug: s.slug }} className="btn">Editar</Link>
                  <button
                    onClick={() => {
                      if (confirm(`Apagar ${s.nome}?`)) del.mutate(s.slug);
                    }}
                    className="btn"
                    style={{ background: '#dc2626', marginLeft: '0.5rem' }}
                  >×</button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </>
  );
}
